import { render } from "./SidenavList.vue?vue&type=template&id=4fd47c3c&scoped=true"
import script from "./SidenavList.vue?vue&type=script&lang=js"
export * from "./SidenavList.vue?vue&type=script&lang=js"

import "./SidenavList.vue?vue&type=style&index=0&id=4fd47c3c&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fd47c3c"]])

export default __exports__